<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :order_sn="componentParams.order_sn"
            :partner_id="componentParams.partner_id">
        </component>
    </div>
</template>
<script>
// 导入订单列表和详情组件
import ShopOrderList from './order/ShopOrderList.vue'
import ShopOrderDetail from './order/ShopOrderDetail.vue'

export default {
    name: 'ShopOrders',
    components: {
        ShopOrderList,
        ShopOrderDetail
    },
    data() {
        return {
            currentComponent: 'ShopOrderList', // 默认显示订单列表
            componentParams: {
                order_sn: '',
                partner_id: ''
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'ShopOrderList';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                // 如果切换到列表组件，重置order_sn
                if (componentName === 'ShopOrderList') {
                    this.componentParams = { 
                        ...this.componentParams, 
                        ...params,
                        order_sn: '' // 重置order_sn
                    };
                } else {
                    this.componentParams = { ...this.componentParams, ...params };
                }
            }
            this.currentComponent = componentName;
        }
    }
}
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>